import React, { useState } from "react";

export default function SocialIcon({ src, alt, link }) {
  const [hover, setHover] = useState(false);

  const ringSize = 64;
  const iconSize = 34;
  const ringBorder = 3;
  const baseLineLength = 30;
  const scaleFactor = hover ? 1.2 : 1;

  // 放大后多出来的半径（图标 + 圆环）大约扩大 ringSize * (scale - 1) / 2
  const extraGap = ((ringSize * scaleFactor) - ringSize) / 2;
  const lineGap = hover ? 0 : 6;
  const lineExtension = hover ? extraGap + lineGap : lineGap;

  return (
      <div
      style={{
        position: "relative",
        width: `${ringSize}px`,
        height: `${ringSize}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {/* 左线 */}
      <div
        style={{
          height: "2px",
          width: `${baseLineLength + lineExtension}px`,
          backgroundColor: "#A3D5FF",
          position: "absolute",
          right: `calc(100% + ${lineGap}px)`,
          top: "50%",
          transform: "translateY(-50%)",
            transition: "width 0.2s ease",
            zIndex: 0,
        }}
      />

      {/* 右线 */}
      <div
        style={{
          height: "2px",
          width: `${baseLineLength + lineExtension}px`,
          backgroundColor: "#A3D5FF",
          position: "absolute",
          left: `calc(100% + ${lineGap}px)`,
          top: "50%",
          transform: "translateY(-50%)",
            transition: "width 0.2s ease",
            zIndex: 0,
        }}
      />

      {/* 圆环与图标 */}
      <a
        href={link || "#"}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: `${ringSize}px`,
            height: `${ringSize}px`,
            borderRadius: "50%",
            border: `${ringBorder}px solid white`,
              backgroundColor: "#003071",
            textDecoration: "none",
            transform: `scale(${scaleFactor})`,
            transition: "transform 0.2s ease, background-color 0.2s ease",
              position: "relative",
              zIndex: 1,
        }}
        >
          <img
            src={src}
            alt={alt}
            width={iconSize}
            height={iconSize}
            style={{
              pointerEvents: "none",
              filter: "invert(100%) brightness(100%)",
              transition: "all 0.2s ease",
              position: "relative",
              zIndex: 2,
            }}
        />
      </a>

    </div>
  );
}
